import React, { ReactElement } from 'react';
import type { Route } from 'next';
import Link from 'next/link';
import classNames from 'classnames/bind';
import Breadcrumbs from 'components/Breadcrumbs';
import styles from 'sections/DigitalTools/components/SectionHeader/SectionHeader.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = (): ReactElement => {
  return (
    <section className={cn('header')}>
      <div className={cn('container')}>
        <Breadcrumbs
          mTop={64}
          mode="light"
          links={[
            { title: 'Digital Tools', href: '' as Route },
          ]}
        />
        <div className={cn('header__content')}>
          <h1 className={cn('header__title')}>Digital Tools for Freight Forwarding</h1>
          <p className={cn('header__title-description')}>
            Digital tools can help you control logistics by enhancing visibility, efficiency, accuracy, and customer satisfaction.
          </p>
          <div className={cn('header__buttons')}>
            <Link className={cn('header__button-contact')} href={"/company/contact-us" as Route}>
              Contact us
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionHeader;